/** SubscriberCard narrow layout; MQ4-style down query (500px) */
export const breakpointsMQ4Small = '@media(width <= 500px)';

export const SUB_CLASS_DROPDOWN_TEST_ID = 'sub-class-dropdown';
export const SUB_NOT_EDITABLE_CLASS_TOOLTIP_TEST_ID = 'sub-not-editable-class-tooltip';
export const SUB_PRODUCT_SELECT_TEST_ID = 'sub-product-select';
export const SUB_PRODUCT_DETAILS_BUTTON_TEST_ID = 'sub-product-details-button';
export const SUB_INELIGIBLE_DEPENDENTS_MESSAGE_TEST_ID = 'sub-ineligible-dependents-message';
export const SUB_NO_DEPENDENTS_MESSAGE_TEST_ID = 'sub-no-dependents-message';
export const SUB_DEPENDENTS_SECTION_TEST_ID = 'sub-dependents-section';
export const SUB_NOT_EDITABLE_PRODUCT_SELECT_TEST_ID = 'sub-not-editable-product-select';
export const SUB_RATE_BUTTON_TEST_ID = 'sub-rate-button';
export const SUB_TOTAL_RATE_VALUE_TEST_ID = 'sub-total-rate-value';
export const SUB_TOTAL_RATE_VALID_VALUE_TEST_ID = 'sub-total-rate-valid-value';
export const SUB_TOTAL_RATE_ERROR_TOOLTIP_TEST_ID = 'sub-total-rate-error-tooltip';
export const SUB_SELECTED_CLASS_TEST_ID = 'sub-selected-class';
export const SUB_PRODUCT_LINE_CARD_TEST_ID = 'sub-product-line-card';
export const SUB_BATCH_CHECKBOX_TEST_ID = 'sub-batch-checkbox';
export const SUB_INCOMPLETE_PROFILE_TAG_TEST_ID = 'sub-incomplete-profile-tag';
export const SUB_REMOVE_SUBSCRIBER_BUTTON_TEST_ID = 'sub-remove-subscriber-button';
export const SUB_MANAGE_DEPENDENTS_BUTTON_TEST_ID = 'sub-manage-dependents-button';
export const SUB_EDIT_SUBSCRIBER_BUTTON_TEST_ID = 'sub-edit-subscriber-button';
export const SUB_NAME_TEST_ID = 'sub-subscriber-name';
export const SUB_CHECK_CIRCLE_ICON_TEST_ID = 'sub-check-circle-icon';
